import { c as _c } from "react/compiler-runtime";
import type { Address } from 'viem';
import { cn } from '@morpho-org/ui-v6/utils';
import { abbreviateAddress } from '@repo/utils';
import { memo } from 'react';
import { AragonDaoLabel } from '../../AragonDaoLabel';
import { SafeQuorum } from '../../SafeQuorum';
interface AddressDataLineLabelProps {
  safeQuorum?: string;
  isAragonDAO?: boolean;
  isMissingAddress?: boolean;
  address?: Address;
  /** text-* class controlling the text variant (default: `text-md`). */
  textClassName?: string;
}
const AddressDataLineLabel = t0 => {
  const $ = _c(13);
  const {
    safeQuorum,
    isAragonDAO,
    isMissingAddress,
    address,
    textClassName: t1
  } = t0;
  const textClassName = t1 === undefined ? "text-md" : t1;
  if (isAragonDAO) {
    let t2;
    if ($[0] !== textClassName) {
      t2 = <AragonDaoLabel textClassName={textClassName} />;
      $[0] = textClassName;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  if (safeQuorum) {
    let t2;
    if ($[2] !== safeQuorum || $[3] !== textClassName) {
      t2 = <SafeQuorum safeQuorum={safeQuorum} textClassName={textClassName} />;
      $[2] = safeQuorum;
      $[3] = textClassName;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t2;
  if ($[5] !== textClassName) {
    t2 = cn(textClassName, "text-foreground");
    $[5] = textClassName;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== address || $[8] !== isMissingAddress) {
    t3 = isMissingAddress ? "No Address." : abbreviateAddress(address);
    $[7] = address;
    $[8] = isMissingAddress;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <span className={t2}>{t3}</span>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export default memo(AddressDataLineLabel);